import { defineChapter } from '../../define';
import boss from './challenges/boss/meta';
import outputOrder from './challenges/output-order/meta';
import strictEquality from './challenges/strict-equality/meta';
import templateLiterals from './challenges/template-literals/meta';
import typeOf from './challenges/typeof/meta';

export default defineChapter({
  id: 'js-values',
  slug: 'values',
  title: 'Values and types',
  position: 1,
  challenges: [outputOrder, typeOf, strictEquality, templateLiterals, boss],
});
